<template>
  <div>
    <!-- 级联选择器 -->
    <el-row class="block">
      <el-col :span="4">
        <el-cascader v-model="value" :options="options" clearable filterable :getCheckedNodes="true" @change="handleChange"> </el-cascader>
      </el-col>
    </el-row>
    <div>
      <el-card class="box-card">
        <!-- <el-row v-if="false" :gutter="40">
          <el-col :span="4">
            添加新闻按钮
            <el-button el-button class="add" type="success" icon="el-icon-plus" @click="goEdit(newsCategoryId)">点击在该列表下添加一条新闻</el-button>
          </el-col>
          <el-col :span="20">
            新闻搜索
            <div>
              <el-input clearable placeholder="请输入所要查询的新闻标题" v-model="title" class="input-with-select input-class"> </el-input>
            </div>
          </el-col>
        </el-row> -->
        <div class="header-tools">
          <div class="search-tools">
            <el-input clearable placeholder="请输入所要查询的新闻标题" @keyup.enter.native="searchKey" v-model="title" class="input-with-select input-class"> </el-input>
            <el-button el-button class="add" icon="el-icon-search" @click="searchKey">搜索</el-button>
          </div>

          <div>
            <el-button el-button class="add" type="success" icon="el-icon-plus" @click="goEdit(newsCategoryId)">点击在该列表下添加一条新闻</el-button>
          </div>
        </div>
        <!-- 新闻表格区域 -->
        <!-- :data="tableData.filter(data => !title || data.title.toLowerCase().includes(title.toLowerCase()))" -->
        <el-table
          :data = "tableData"
          border
          style="width: 100%"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
        >
          <el-table-column type="index" label="序号" width="50">
            <template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="releaseTime" label="日期" width=""> </el-table-column>
          <el-table-column prop="title" label="新闻标题" width=""> </el-table-column>
          <el-table-column prop="id" label="id" width=""> </el-table-column>
          <el-table-column label="操作" width="">
            <template slot-scope="scope">
              <!-- {{ scope.row.id }} -->
              <div>
                <el-button type="success" @click="look(scope.row.id)">查看</el-button>
                <el-button type="warning" @click="showEditDialog(scope.row.id)">修改</el-button>
                <el-button type="info" @click="deleteNews(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div>
          <!-- 获取新闻列表分页 -->
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[6, 12, 18]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>
      <!-- 修改新闻的对话框 -->
      <el-dialog title="修改新闻" :visible.sync="editDialogVisible" width="50%" :before-close="handleClose">
        <div>
          <div>
            <!-- rules表单验证规则，ref当前表单的验证对象 -->
            <el-form ref="editFormRef" :model="editForm" label-width="80px" status-icon>
              <el-form-item hidden label="id:">
                <el-input v-model="editForm.id" disabled></el-input>
              </el-form-item>
              <el-form-item label="新闻标题:">
                <el-input v-model="editForm.title"></el-input>
              </el-form-item>
              <el-form-item label="发布日期:">
                <el-date-picker v-model="editForm.releaseTime" type="date" placeholder="请选择发布日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
              <el-form-item label="新闻内容:">
                <div style="height: 436px;">
                  <quill-editor ref="text" v-model="editForm.content" class="myQuillEditor" :options="editorOption" @change="onEditorChange($event)" />
                  <input type="file" accept=".webp,.png,.jpg,.jpeg" @change="changePic" multiple id="quillPicUpload"
                         style="display: none" />
                  <input type="file" accept="video/*" @change="changeVideo" id="quillVideoUpload" style="display: none" />
                  <input type="file" @change="changeFile" id="quillFileUpload" style="display: none" />
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div style="display: flex; justify-content: right;">
            <span slot="footer" class="dialog-footer">
              <el-button @click="cancelEdit">取 消</el-button>
              <el-button type="primary" @click="editNew()">确 定</el-button>
            </span>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getOptions } from '@/api/type.js'
import axios from 'axios'
import global from '@/utils/global.js'
import { getNewsList, getnew, update, deleteNew, fuzzy } from '../../api/api'
import { quillEditor, Quill } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { ImageExtend, QuillWatch } from 'quill-image-extend-module'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
Quill.register('modules/ImageExtend', ImageExtend)

export default {
  data() {
    return {
      title: '',
      init: true,
      getShow: true, //获取分页的显示(布尔值)
      gettable: true, //获取表格的显示
      visible: false,
      editDialogVisible: false, //控制修改对话框的布尔值
      AdDialogVisible: false, //超管登录对话框
      Ad: { username: '', password: '' }, //超管对象
      editForm: {}, //查询到的新闻对象，目前仅供修改使用
      parentCategoryId: null, //一级分类id
      newsCategoryId: null, //先存一个小标题id
      tableData: [], //新闻列表对象
      fuzzytableData: [], //模糊查询列表对象
      pageSize: 6, //每页条数
      currentPage: 1, //当前页
      total: 0, //新闻总条数
      fuzzyShow: false, //模糊查询分页的显示(布尔值)
      fuzzytable: false, //模糊查询表格的显示
      fuzzyForm: { fuzzytitle: '', fuzzytotal: 0, fuzzycurrent: 1, fuzzysize: 6 }, //模糊查询列表对象
      value: [],
      options: [],
      editorOption: {
        placeholder: '请输入正文',
        modules: {
          /* ImageExtend: {
            // 如果不作设置，即{}  则依然开启复制粘贴功能且以base64插入
            name: 'file', // 图片参数名
            loading: true,
            size: 10, // 可选参数 图片大小，单位为M，1M = 1024kb
            action: global.baseURL + 'uploading',
            response: res => {
              // console.log(res)
              return global.baseURL +  res.data
            },
            headers: xhr => {
              // axios.defaults.withCredentials = true;
              // xhr.setRequestHeader('Cookie','NMTID=00OVM6QOJcTDVhqDUtvgSnd-5FBxLcAAAF9nTiDHg; JSESSIONID=5ACC52D29A2434E09450CB975E08C288')
            }, // 可选参数 设置请求头部
            sizeError: () => {}, // 图片超过大小的回调
            start: () => {}, // 可选参数 自定义开始上传触发事件
            end: () => {}, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            error: () => {}, // 可选参数 上传失败触发的事件
            success: () => {}, // 可选参数  上传成功触发的事件
            change: (xhr, formData) => {
              // formData.append('token', 'myToken')
            } // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
          }, */
          imageDrop: true,
          imageResize: {
              handleStyles: {
                displaySize: true,
                backgroundColor: "black",
                border: "none",
                color: "white",
              },
              modules: ["Resize", "DisplaySize"],
          },
          clipboard: {
            matchers: [[Node.ELEMENT_NODE, this.stopImgClip]],
          },
          toolbar: {
            /* container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'], // 引用，代码块
              [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
              [{ list: 'ordered' }, { list: 'bullet' }], // 列表
              [{ script: 'sub' }, { script: 'super' }], // 上下标
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              [{ direction: 'rtl' }], // 文本方向
              [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
              [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
              [{ font: [] }], // 字体
              [{ align: [] }], // 对齐方式
              ['clean'], // 清除字体样式
              ['image'] // 上传图片、上传视频
            ],
            handlers: {
              image: function() {
                // 劫持原来的图片点击按钮事件
                QuillWatch.emit(this.quill.id)
              }
            } */
            container: [
                ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
                ['blockquote', 'code-block'], // 引用  代码块-----['blockquote', 'code-block']
                [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
                [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
                [{ script: 'sub' }, { script: 'super' }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
                [{ indent: '-1' }, { indent: '+1' }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
                [{ direction: 'rtl' }], // 文本方向-----[{'direction': 'rtl'}]
                [{ size: ['12px', '100%', '16px', '18px', '20px', '22px', '24px', '28px', '32px', '48px'] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
                [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
                [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
                [{ font: [] }], // 字体种类-----[{ font: [] }]
                [{ align: [] }], // 对齐方式-----[{ align: [] }]
                ['clean'], // 清除文本格式-----['clean']
                ['image'], // 链接、图片、视频-----['link', 'image', 'video']
                [{ table: 'TD' }, { 'table-insert-row': 'TIR' }, { 'table-insert-column': 'TIC' }, { 'table-delete-row': 'TDR' }, { 'table-delete-column': 'TDC' }],
            ],
            handlers: {
                table: function(val) {
                  this.quill.getModule('table').insertTable(2, 3)
                },
                'table-insert-row': function() {
                  this.quill.getModule('table').insertRowBelow()
                },
                'table-insert-column': function() {
                  this.quill.getModule('table').insertColumnRight()
                },
                'table-delete-row': function() {
                  this.quill.getModule('table').deleteRow()
                },
                'table-delete-column': function() {
                  this.quill.getModule('table').deleteColumn()
                },
                image: function (value) {
                    if (value) {
                        document.querySelector('#quillPicUpload').click() // 劫持原来的图片点击按钮事件
                    } else {
                        this.quill.format('image', false)
                    }
                },
                video: function (value) {
                    if (value) {
                        document.querySelector('#quillVideoUpload').click()
                    } else {
                        // return
                        this.quill.format('video', false)
                    }
                },
                // 文件上传
                upload: value => {
                    if (value) {
                        document.querySelector('#quillFileUpload').click()
                    } else {
                        this.quill.format('upload', false)
                    }
                }
            }
          },
          table: true,
        }
      }, // 编辑器新闻对象
      fileList: []
    }
  },
  components: {
    quillEditor
  },
  created() {},
  mounted() {
    this.generateOptions();
    this.query(this.newsCategoryId);
  },
  methods: {
    // 图片上传
    changePic(e) {
        let fileList = e.target.files
        let formData = new FormData()
        for (let i = 0; i < fileList.length; i++) {
            formData.append('file', fileList[i])
        }
        axios
            .post(global.baseURL + 'uploading', formData)
            .then(res => {
                //console.log(res.data.update_image)
                if (res.data.code == 200) {
                    let picList = global.fileServer + "file/getFile?fileName=" + res.data.data
                    if (this.editForm.picturePath == null || this.editForm.picturePath == undefined) {
                      this.editForm.picturePath = res.data.data
                    }
                    let quill = this.$refs.text.quill

                    let index = quill.getSelection().index // 光标位置
                    //console.log("picList", picList)
                    quill.insertEmbed(index, 'image', picList) // 插入图片  图片地址
                    // 调整光标到最后
                    quill.setSelection(index + 1) // 光标后移一位
                } else {
                    this.$message({
                        message: '图片上传失败：',
                        type: 'error'
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })
    },
    // 上传视频
    changeVideo(e) {
        this.$message.warning('不支持上传视频')
    },
    // 上传文件
    changeFile(e) { },
    stopImgClip(node, Delta) {
        if (this.init) {
          return Delta;
        }

        let ops = []
        Delta.ops.forEach(op => {
            //console.log("op insert:", op.insert)
            if (op.insert && typeof op.insert === 'string') {
                ops.push({
                    insert: op.insert,
                })
            } else { //给出提醒
                if (op.insert.image) {
                    if (!op.insert.image.includes("base64")) {
                      this.$message({
                        message: '图片格式不正确',
                        type: 'error',
                      });
                      return;
                    }
                    //给个提示
                    this.$message({
                        message: '粘贴的内容是图片',
                        type: 'warning',

                    })
                    //调用方法
                    this.mybase64tofileandupload(op.insert.image)
                }
            }
        })
        Delta.ops = ops
        //console.log("ops", ops);
        return Delta
    },
    mybase64tofileandupload(image) {
      //console.log("image base64", image);
      let formData = new FormData()
      formData.append('image', image)

      // 上传base64图片
      axios.post(global.baseURL + "/saveImage", formData)
              .then(res => {
                //console.log("mybase64tofileandupload", res.data)
                if (res.data.code == 200) {
                    let picList = global.fileServer + "file/getFile?fileName=" + res.data.data
                    if (this.editForm.picturePath == null || this.editForm.picturePath == undefined) {
                      this.editForm.picturePath = res.data.data
                    }
                    let quill = this.$refs.text.quill

                    let index = quill.getSelection().index // 光标位置
                    //console.log("picList", picList)
                    quill.insertEmbed(index, 'image', picList) // 插入图片  图片地址
                    // 调整光标到最后
                    quill.setSelection(index + 1) // 光标后移一位
                } else {
                    this.$message({
                        message: '图片上传失败：',
                        type: 'error'
                    })
                }
            })
            .catch(err => {
                console.log(err)
            })
    },
    onEditorChange(event) {
      //this.$emit('getEditorInfo', event)
      this.init = false;
    },
    cancelEdit() {
      this.editDialogVisible = false;
      this.init = true;
    },
    //修改对话框关闭的方法
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.init = true;
          done()
        })
        .catch(_ => {})
    },
    // 标题搜索
    searchKey() {
      const data = {
        current: this.currentPage,
        size: this.pageSize,
        newsCategoryId: this.newsCategoryId,
        title: this.title
      }
      this.doGetNewsList(data)
    },
    //级联选择器的方法
    handleChange(value) {
      // console.log(value);
      // console.log(value[1]);
      this.currentPage = 1
      this.parentCategoryId = value[0]
      this.newsCategoryId = value[1] //将得到的小标题id存放起来
      this.query(this.newsCategoryId)
    },
    query(newsCategoryId) {
      const data = {
        current: this.currentPage,
        newsCategoryId: newsCategoryId,
        size: this.pageSize
      }
      this.doGetNewsList(data)
    },
    //展示修改对话框
    showEditDialog(id) {
      getnew(id).then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.editForm = res.data
        }
      })
      this.editDialogVisible = true
    },
    //确定修改表单提交，验证发起请求
    editNew() {
      const data = {
        id: this.editForm.id,
        releaseTime: this.editForm.releaseTime,
        title: this.editForm.title,
        content: this.editForm.content,
        picturePath: this.editForm.picturePath
      }
      update(data, undefined).then(res => {
        // console.log('dsadasas', res)
        if (res.code == 200) {
          this.editDialogVisible = false
          this.$message.success('修改新闻成功！')
          this.query(this.newsCategoryId)
        } else {
          this.$message.error(res.msg);
        }
        this.init = true;
      })
    },
    doGetNewsList(data) {
      getNewsList(data)
        .then(res => {
          // console.log(res);
          if (res.code !== 200) {
            return this.$message.error('获取新闻列表失败')
          } else {
            this.tableData = res.data.records
            this.total = res.data.total
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    //模糊查询
    fuzzyList(title) {
      // console.log(title);
      if (title == '') {
        return this.$message.error('请先输入查询新闻标题！')
      }
      this.fuzzyShow = true //模糊分页显示
      this.getShow = false //获取分页隐藏
      this.gettable = false
      this.fuzzytable = true
      const data = {
        current: this.fuzzyForm.fuzzycurrent,
        size: this.fuzzyForm.fuzzysize,
        title: title
      }
      fuzzy(data)
        .then(res => {
          // console.log(res);
          if (res.code !== 200) {
            return this.$message.error('查询新闻列表失败')
          } else {
            this.fuzzytableData = res.data.records
            this.fuzzyForm.fuzzytotal = res.data.total
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    //清空查询列表内容
    qingKong() {
      this.tableData = []
      this.fuzzytableData = []
      this.fuzzyForm.fuzzytotal = 0
      this.fuzzyShow = false
      this.getShow = true
      this.fuzzytable = false
      this.gettable = true
    },
    //根据id删除新闻
    async deleteNews(id) {
      // console.log(id);
      const res = await this.$confirm('此操作将永久删除该条新闻, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => {
        return err
      })
      //如果用户点击确定则返回confirm
      //如果用户点击取消则返回cancel
      // console.log(res)
      if (res !== 'confirm') {
        return this.$message.info('已取消删除~')
      } else {
        // console.log(id)
        const data = {
          id: id
        }
        //参数data 要以对象的形式传入
        deleteNew(data).then(res => {
          // console.log('>>>' + res)
          if (res.code == 200) {
            this.$message.success('删除新闻成功！')
            this.query(this.newsCategoryId)
          } else {
            return this.$message.error('删除新闻失败！')
          }
        })
      }
    },
    //查看
    look(id) {
      this.$router.push({ path: 'news', query: { id: id } })
    },
    //超管登录对话框
    showAdDialog() {
      this.AdDialogVisible = true
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val
      this.query(this.newsCategoryId)
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.query(this.newsCategoryId)
    },
    handleCurrentChangefuzzy(val) {
      this.fuzzyForm.fuzzycurrent = val
      this.fuzzyList(this.fuzzyForm.fuzzytitle) //模糊查询
    },
    handleSizeChangefuzzy(val) {
      this.fuzzyForm.fuzzysize = val
      this.fuzzyList(this.fuzzyForm.fuzzytitle) //模糊查询
    },
    //去往添加编辑页面
    goEdit(id) {
      let title = ''
      // console.log(this.value)
      if ((this.value.length = 2)) {
        let t = this.value[0]
        let i = this.value[1]
        this.options.forEach(item => {
          if (item.value == t) {
            title += item.label + '/'
            if (item.children != undefined) {
              item.children.forEach(e => {
                if (e.value == i) title += e.label
              })
            }
          }
        })
      }
      /* if (
        (this.newsCategoryId == 27 && this.total == 1) ||
        (this.newsCategoryId == 28 && this.total == 1) ||
        (this.newsCategoryId == 29 && this.total == 1) ||
        (this.newsCategoryId == 30 && this.total == 1) ||
        (this.newsCategoryId == 31 && this.total == 1)
      ) {
        this.$message.error('该新闻标题下只能存在一篇新闻')
      } else if (
        this.newsCategoryId == 27 ||
        this.newsCategoryId == 28 ||
        this.newsCategoryId == 29 ||
        this.newsCategoryId == 30 ||
        this.newsCategoryId == 31 ||
        this.newsCategoryId == 35 ||
        this.newsCategoryId == 36 ||
        this.newsCategoryId == 37 ||
        this.newsCategoryId == 38 ||
        this.newsCategoryId == 39 ||
        this.newsCategoryId == 40 ||
        this.newsCategoryId == 41 ||
        this.newsCategoryId == 42 ||
        this.newsCategoryId == 43 ||
        this.newsCategoryId == 44
      ) {
        this.$router.push({ path: '/administrator/edit', query: { id: id, title: title } })
        // console.log(this.newsCategoryId)
      } else if (this.newsCategoryId == 45) {
        this.$router.push({ path: '/administrator/editlunbo', query: { id: id, title: title } })
        // console.log(this.newsCategoryId);
      } else {
        this.$message.error('请先选择新闻标题')
      } */
      if (this.newsCategoryId == undefined) {
        this.$message.error('请先选择新闻标题')
      } else {
        this.$router.push({ path: '/administrator/edit', query: { id: id, title: title } })
      }
    },
    generateOptions() {
      this.options = []
      getOptions().then(res => {
        if (res.code == 200) {
          let list = res.data
          for (let i = 0; i<list.length; i++) {
            let c = list[i]
            this.options.push({
              value: c.id,
              label: c.name
            })
            if (c.children != undefined && c.children.length > 0) {
              this.options[this.options.length - 1].children = []
              for (let k = 0; k < c.children.length; k++) {
                let child = c.children[k]
                this.options[this.options.length - 1].children.push({
                  value: child.id,
                  label: child.name
                })
              }
            }
          }
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
.add {
  margin-bottom: 10px !important;
}
.block {
  margin-bottom: 10px;
}
.el-pagination {
  margin-top: 10px;
}
.input-class {
  width: 260px;
}
.header-tools {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.search-tools {
  display: flex;
  div {
    margin-right: 10px;
  }
}
.myQuillEditor {
  height: 350px;
}
.btn {
  position: absolute;
  bottom: 20px;
  left: 168px;
}

</style>
